// @flow strict

export type Product = {
  title: string,
  price: number,
};

export const PRICEOVERVIEW_POSITION_JOURNEY = 1;
export const PRICEOVERVIEW_POSITION_INSURANCE = 2;
export const PRICEOVERVIEW_POSITION_COVIDINSURANCE = 3;
export const PRICEOVERVIEW_POSITION_RESERVATIONOPTION = 4;
export const PRICEOVERVIEW_POSITION_FLEXOPTION = 5;
export const PRICEOVERVIEW_POSITION_RESERVATION = 6;
